import { Component } from '@angular/core';
import * as Highcharts from 'highcharts';
import { OrderServiceService } from 'src/app/services/orders/order-service.service';

@Component({
  selector: 'app-monthly-sales-summary',
  templateUrl: './monthly-sales-summary.component.html',
  styleUrls: ['./monthly-sales-summary.component.scss'],
})
export class MonthlySalesSummaryComponent {
  Highcharts: typeof Highcharts = Highcharts;
  options: any;
  months = {
    '01': 'Enero',
    '02': 'Febrero',
    '03': 'Marzo',
    '04': 'Abril',
    '05': 'Mayo',
    '06': 'Junio',
    '07': 'Julio',
    '08': 'Agosto',
    '09': 'Septiembre',
    '10': 'Octubre',
    '11': 'Noviembre',
    '12': 'Diciembre',
  };

  constructor(private orderService: OrderServiceService) {}

  ngOnInit() {
    this.getData();
  }

  convert;

  async getData() {
    const date = [];
    const values = [];
    const years = [];
    this.orderService.monthly_sales_summary().then((response: any) => {
      for (let data of response) {
        const month = data.date.split('-');
        values.push(Math.floor(data.total / 100));
        date.push(`${this.months[month[1]]}-${month[0]}`);
        if (!years.includes(month[0])) {
          years.push(month[0]);
        }
      }
    });
    await fetch('https://demo-live-data.highcharts.com/aapl-v.json').then(
      (response) => response.json()
    );

    Highcharts.chart('container', {
      chart: {
        alignTicks: false,
      },
      yAxis: {
        title: {
          text: 'Valores'
        }
      },

      xAxis: {
        categories: date,
        crosshair: true,
      },

      rangeSelector: {
        selected: 1,
      },

      title: {
        text: `Resumen de ventas mensales - ${years[years.length-1]}`,
      },

      series: [
        {
          type: 'column',
          name: 'Tus ventas fueron de',
          data: values,
        },
      ],
    });
  }
}
